import React from 'react';

import classes from './NgzPageUnderConstruction.module.scss';
import { angularizeWithProviders } from '../../providers';

import ReportsSvg from '../../assets/image/under-construction/reports.svg';

const underConstructionImagesMap = {
  reports: ReportsSvg,
};

export type PageUnderConstructionProps = {
  title?: string;
  description?: string;
  imageType: keyof typeof underConstructionImagesMap;
};

const PageUnderConstruction = ({
  title = 'Coming soon!',
  description,
  imageType,
}: PageUnderConstructionProps) => {
  if (!imageType) {
    return null;
  }

  return (
    <div className={classes.underConstructionFallback}>
      <h3 className={classes.fallbackTitle}>{title}</h3>
      <p className={classes.fallbackDescription}>{description}</p>
      <img src={underConstructionImagesMap[imageType]} alt="under-construction" />
    </div>
  );
};

angularizeWithProviders(PageUnderConstruction, 'ngzPageUnderConstruction', {
  title: '@',
  description: '@',
  imageType: '@',
});

export { PageUnderConstruction };
